import { render, staticRenderFns } from "./MyDormGaleri2.vue?vue&type=template&id=481077af&"
import script from "./MyDormGaleri2.vue?vue&type=script&lang=js&"
export * from "./MyDormGaleri2.vue?vue&type=script&lang=js&"
import style0 from "./MyDormGaleri2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MyDormGaleri2.vue"
export default component.exports